import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

function _window(): any {
	// return the global native browser window object
	return window;
}

declare var device;

@Component({
	selector: 'app-authaftergoogle',
	templateUrl: './authaftergoogle.component.html',
	styleUrls: ['./authaftergoogle.component.css'],
	standalone: true
})
export class AuthAfterGoogle implements OnInit {
	constructor(private router: Router) {}

	ngOnInit() {
		if (typeof device != 'undefined') {
			_window().cordova.InAppBrowser.close();
		} else {
			this.router.navigate(['home']);
		}
	}
}
